import { useEffect } from 'react';
import pb from '../lib/pb';

export function useGoogleOAuth(onCompleted: () => void) {
  useEffect(() => {
    (async () => {
      const code = sessionStorage.getItem('pb_oauth_code');
      if (!code) return;

      const stateReturned = sessionStorage.getItem('pb_oauth_state_returned') || '';
      const expectedState = sessionStorage.getItem('pb_oauth_state') || '';
      const verifier = sessionStorage.getItem('pb_oauth_verifier') || '';
      const callbackUrl = `${window.location.origin}/oauth2-callback`;

      try {
        if (!verifier || stateReturned !== expectedState) throw new Error('Invalid OAuth state');
        await pb.collection('users').authWithOAuth2Code('google', code, verifier, callbackUrl);
        onCompleted();
      } catch (err) {
        console.error('[OAuth] exchange failed:', err);
      } finally {
        sessionStorage.removeItem('pb_oauth_code');
        sessionStorage.removeItem('pb_oauth_state_returned');
        sessionStorage.removeItem('pb_oauth_state');
        sessionStorage.removeItem('pb_oauth_verifier');
      }
    })();
  }, [onCompleted]);
}